import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, nextTick, onMounted, onUnmounted, provide, ref } from "vue";
import { useStore } from "@/store";
import { Mutations } from "@/store/enums/StoreEnums";
import { initializeComponents } from "@/core/plugins/plugins";
import { updateWidth } from "@/core/config/WindowConfig";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import en from "element-plus/dist/locale/en.mjs";
import zhTw from "element-plus/dist/locale/zh-tw.mjs";
import viVN from "element-plus/dist/locale/vi.mjs";
import thTH from "element-plus/dist/locale/th.mjs";
import jpJP from "element-plus/dist/locale/ja.mjs";
import mnMN from "element-plus/dist/locale/mn.mjs";
import idID from "element-plus/dist/locale/id.mjs";
import msMY from "@vee-validate/i18n/dist/locale/ms_MY.json";
import UserFileDocModal from "@/components/ClientUserFileDocModal.vue"; // Todo: change pdfjs lib
import ClientGlobalInjectionKeys from "@/core/types/ClientGlobalInjectionKeys";
import ImageViewer from "./components/ImageViewer.vue";
import RejectReasonBox from "@/components/RejectReasonBox.vue";
import ConfirmBox from "@/components/ConfirmBox.vue";
import AddCommentModal from "@/components/modal/AddCommentModal.vue";
import ChatIndex from "@/components/Chat/ChatIndex.vue";
import { getLanguage } from "@/core/types/LanguageTypes";

export default /*#__PURE__*/_defineComponent({
  __name: 'ClientApp',
  setup(__props) {

const store = useStore();
const token = ref<any>("");
const langMap = {
  ["en-us"]: en,
  ["zh-cn"]: zhCn,
  ["zh-tw"]: zhTw,
  ["vi-vn"]: viVN,
  ["th-th"]: thTH,
  ["jp-jp"]: jpJP,
  // ["mn-mn"]: mnMN,
  ["id-id"]: idID,
  // ["ms-my"]: msMY,
};
// const language = computed(
//   () => store?.state?.authModule?.user?.language ?? "en-us"
// );
const elementLocale = computed(() => langMap[getLanguage.value] ?? en);
const userFileDocModalRef = ref<InstanceType<typeof UserFileDocModal>>();
const confirmBoxRef = ref<InstanceType<typeof ConfirmBox>>();
const rejectReasonBoxRef = ref<InstanceType<typeof RejectReasonBox>>();
const addCommentModalRef = ref<InstanceType<typeof AddCommentModal>>();
onMounted(async () => {
  provide(
    ClientGlobalInjectionKeys.OPEN_FILE_MODAL,
    userFileDocModalRef.value?.show
  );
  provide(
    ClientGlobalInjectionKeys.OPEN_CONFIRM_MODAL,
    confirmBoxRef.value?.show
  );
  provide(
    ClientGlobalInjectionKeys.OPEN_REJECT_REASON_MODAL,
    rejectReasonBoxRef.value?.show
  );
  provide(
    ClientGlobalInjectionKeys.OPEN_ADD_COMMENT_MODAL,
    addCommentModalRef.value?.show
  );
  provide(ClientGlobalInjectionKeys.IMG_SHOW_REF, userFileDocModalRef);
  /**
   * Overrides the layout config using saved data from localStorage
   * remove this to use static config (@/core/config/DefaultLayoutConfig.ts)
   */
  store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);
  window.addEventListener("resize", updateWidth);
  /** tbd
   *  Sets a mode from configuration
   *
   */
  nextTick(() => {
    initializeComponents();
  });
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWidth);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createBlock(_component_el_config_provider, { locale: elementLocale.value }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view),
      _createVNode(UserFileDocModal, {
        ref_key: "userFileDocModalRef",
        ref: userFileDocModalRef
      }, null, 512),
      _createVNode(ConfirmBox, {
        ref_key: "confirmBoxRef",
        ref: confirmBoxRef
      }, null, 512),
      _createVNode(RejectReasonBox, {
        ref_key: "rejectReasonBoxRef",
        ref: rejectReasonBoxRef
      }, null, 512),
      _createVNode(AddCommentModal, {
        ref_key: "addCommentModalRef",
        ref: addCommentModalRef
      }, null, 512)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})